import React from "react";
import style from "./QuizFooter.module.scss";

type Props = {};

const QuizFooter = (props: Props) => {
  return <div className={style.container}></div>;
};

export default QuizFooter;
